var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C14.5899 0 6.5 8.47059 6.5 18.9656C6.5 27.0633 17.6236 41.2342 22.427 46.9878C22.9326 47.6271 23.691 48 24.5 48C25.309 48 26.0674 47.6271 26.573 46.9878C31.3764 41.2342 42.5 27.0633 42.5 18.9656C42.5 8.47059 34.4101 0 24.5 0ZM24.5 29.4606C18.9888 29.4606 14.4888 24.7192 14.4888 18.9123C14.4888 13.1054 18.9888 8.41731 24.5 8.41731C30.0112 8.41731 34.5112 13.1587 34.5112 18.9656C34.5112 24.7725 30.0112 29.4606 24.5 29.4606Z",
    fill: "#00826D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5461 10.7998C21.4068 10.7998 22.2322 11.1417 22.8408 11.7503C23.4495 12.3589 23.7914 13.1844 23.7914 14.0451V17.2904H20.5461C19.6854 17.2904 18.8599 16.9485 18.2513 16.3399C17.6427 15.7313 17.3008 14.9058 17.3008 14.0451V14.0451C17.3008 13.1844 17.6427 12.3589 18.2513 11.7503C18.8599 11.1417 19.6854 10.7998 20.5461 10.7998V10.7998Z",
    fill: "#00826D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3008 21.9549C17.3008 21.0942 17.6427 20.2687 18.2513 19.6601C18.8599 19.0515 19.6854 18.7096 20.5461 18.7096H23.7914V21.9549C23.7914 22.8156 23.4495 23.6411 22.8409 24.2497C22.2322 24.8583 21.4068 25.2002 20.5461 25.2002V25.2002C19.6854 25.2002 18.8599 24.8583 18.2513 24.2497C17.6427 23.6411 17.3008 22.8156 17.3008 21.9549Z",
    fill: "#00826D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4539 25.2002C27.5932 25.2002 26.7678 24.8583 26.1592 24.2497C25.5505 23.6411 25.2086 22.8156 25.2086 21.9549V18.7096H28.4539C29.3146 18.7096 30.1401 19.0515 30.7487 19.6601C31.3573 20.2687 31.6992 21.0942 31.6992 21.9549C31.6992 22.8156 31.3573 23.6411 30.7487 24.2497C30.1401 24.8583 29.3146 25.2002 28.4539 25.2002Z",
    fill: "#00826D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6992 14.0451C31.6992 14.9058 31.3573 15.7313 30.7487 16.3399C30.1401 16.9485 29.3146 17.2904 28.4539 17.2904H25.2086V14.0451C25.2086 13.1844 25.5505 12.3589 26.1592 11.7503C26.7678 11.1417 27.5932 10.7998 28.4539 10.7998C29.3146 10.7998 30.1401 11.1417 30.7487 11.7503C31.3573 12.3589 31.6992 13.1844 31.6992 14.0451V14.0451Z",
    fill: "#00826D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.b6066cc73366ddc93a76b553678d44f9.svg";
export { ForwardRef as ReactComponent };